import styled from 'styled-components';

export const ChipContainer = styled.div`
    .MuiChip-deleteIcon {
        &.delete-icon {
            width: 20px;
            height: 20px;
            color: ${(props) => props.theme.palette.primaryA6};

            &:hover {
                color: ${(props) => props.theme.palette.primaryA7};
            }
        }
    }
`;
